import * as React from 'react';
import './CancelOrderModal.scss';
import accounting from 'accounting';
import Select2 from 'src/components/common/Select2';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';
import OrderLineModel from 'src/model/orderline.model';
import PartReturnModel from 'src/model/partReturn.model';
import i18n from 'src/translation/i18n';

export interface ICancelOrderModalProps {
  order: OrderLineModel[] | PartReturnModel;
  poNumber: string;
  date: string;
  handleShowHideModal: () => void;
  onSubmitCancellation: (order: OrderLineModel[] | PartReturnModel) => void;
  t?: any;
}

export interface ICancelOrderModalState {
  selectedReason: ISelectOption;
  comments: string;
  optionsError: boolean;
}

class CancelOrderModal extends React.Component<
  ICancelOrderModalProps,
  ICancelOrderModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      selectedReason: null,
      comments: '',
      optionsError: false
    };
  }

  private handleSelectReason = (selectedReason: ISelectOption) => {
    this.setState({ selectedReason });
  };

  private handleCommentsChange = (comments: string) => {
    this.setState({ comments });
  };

  private onSubmitCancellation = () => {
    if (!this.state.selectedReason) {
      this.setState({ optionsError: true });
      return;
    }
    this.setState({ optionsError: false });
    this.props.onSubmitCancellation(this.props.order);
    this.props.handleShowHideModal();
  };

  private renderCancelOrden = (order: OrderLineModel[]) => {
    return order.map((details, idx) => {
      return (
        <div key={idx} className="description-row order--part-number">
          <span className="order--part-number">{`${details.manufacturerCode} ${details.productNumber}`}</span>
          <span className="qty">{details.quantity}</span>
          <span>{accounting.formatMoney(details.price)}</span>
          <span>{accounting.formatMoney(details.amount)}</span>
        </div>
      );
    });
  };

  private renderCancelItem = (item: PartReturnModel) => {
    return (
      <div className="description-row order--part-number">
        <span className="order--part-number">{`${item.manufacturerCode} ${item.productNumber}`}</span>
        <span className="qty">{item.quantity}</span>
        <span>{accounting.formatMoney(item.price)}</span>
        <span>{accounting.formatMoney(item.amount)}</span>
      </div>
    );
  };

  private renderOrdenHeader = (order: OrderLineModel[]) => {
    const { date, poNumber, t } = this.props;
    return (
      <div className="rp-order-cancellation-modal-order-info">
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myOrders.searchByKeys.orderNumber')}:{' '}
          <span className="data-text">{order[0].orderNumber}</span>
        </div>
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myOrders.orderDate')}: <span className="data-text">{date}</span>
        </div>
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myReturns.pONumber')}:{' '}
          <span className="data-text">{poNumber}</span>
        </div>
      </div>
    );
  };

  private renderItemHeader = (item: PartReturnModel) => {
    const { date, poNumber, t } = this.props;
    return (
      <div className="rp-order-cancellation-modal-order-info">
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myOrders.searchByKeys.orderNumber')}:{' '}
          <span className="data-text">{item.orderNumber}</span>
        </div>
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myOrders.orderDate')}: <span className="data-text">{date}</span>
        </div>
        <div className="rp-order-cancellation-modal-order-info-data">
          {t('myReturns.pONumber')}:{' '}
          <span className="data-text">{poNumber}</span>
        </div>
      </div>
    );
  };

  private renderModalType() {
    const { order } = this.props;
    if (Array.isArray(order)) {
      return this.renderCancelOrden(order);
    } else {
      return this.renderCancelItem(order);
    }
  }

  private renderModalHeader() {
    const { order } = this.props;
    if (Array.isArray(order)) {
      return this.renderOrdenHeader(order);
    } else {
      return this.renderItemHeader(order);
    }
  }

  public render() {
    const { handleShowHideModal, t } = this.props;
    const options = [
      {
        name: `${i18n.t('myOrders.orderCreatedByMistake')}`,
        value: 'order created by mistake'
      },
      {
        name: `${i18n.t('myOrders.myCustomerCancelled')}`,
        value: 'my customer cancelled'
      },
      { name: `${i18n.t('myOrders.notInStock')}`, value: 'not in stock' },
      {
        name: `${i18n.t('myOrders.noEtaArrive')}`,
        value: 'No ETA/ item(s) would not arrive on time'
      },
      {
        name: `${i18n.t('myOrders.itemPriceHigh')}`,
        value: 'Item price too high'
      },
      {
        name: `${i18n.t('myOrders.shipCostHigh')}`,
        value: 'Shipping cost too high'
      },
      {
        name: `${i18n.t('myOrders.foundCheaper')}`,
        value: 'Found cheaper somewhere else'
      },
      { name: `${i18n.t('myOrders.other')}`, value: 'other' }
    ];

    return (
      <div className="rp-order-cancellation-modal">
        <div className="title">Order to Cancel</div>
        {this.renderModalHeader()}
        <div className="rp-order-cancellation-modal-order-reason">
          <label>{t('common.cancellationReason')}:*</label>
          <div onClick={() => this.setState({ optionsError: false })}>
            <Select2
              label=""
              options={options}
              selected={this.state.selectedReason}
              placeholder="Select a Cancellation reason"
              onSelect={sel => this.handleSelectReason(sel)}
              className={'cancellation-reason-options'}
              onError={this.state.optionsError}
            />
          </div>
        </div>
        <div className="rp-order-cancellation-modal-order-comments">
          <label>{t('feedbackForm.comments')}:</label>
          <textarea
            className="rp-order-cancellation-modal-order-textarea"
            value={this.state.comments}
            onChange={e => this.handleCommentsChange(e.target.value)}
            rows={8}
            required={true}
          />
        </div>
        <div className="rp-order-cancellation-modal-order-actions">
          <button
            className="cancel-action"
            onClick={() => handleShowHideModal()}
          >
            {t('common.cancel')}
          </button>
          <button className="submit-action" onClick={this.onSubmitCancellation}>
            {t('common.submitCancellation')}
          </button>
        </div>
        <div className="rp-order-cancellation-modal-orders-table">
          <div className="orders-header">
            <span>{t('myReturns.partNumber')}</span>
            <span className="qty">{t('myFavourites.qty')}</span>
            <span>{t('common.price')}</span>
            <span>{t('common.amount')}</span>
          </div>
          <div className="orders-description">{this.renderModalType()}</div>
        </div>
      </div>
    );
  }
}

export default CancelOrderModal;
